import { Phone } from "lucide-react";
import { trackContact } from "../lib/track";

const LINKS = [
  ["Services", "#services"],
  ["Fleet", "#fleet"],
  ["Coverage", "#coverage"],
  ["Contact", "#contact"],
];

export const Nav = () => (
  <header data-testid="nav-header" className="fixed top-0 inset-x-0 z-50 glass border-b border-gold-400/10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
      <a href="#top" data-testid="nav-brand-logo" className="flex items-center gap-2.5 shrink-0">
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full rounded-full bg-gold-400 opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold-400" />
        </span>
        <span className="font-display font-extrabold tracking-wide text-sm sm:text-base text-white">
          SYDNEY <span className="text-gold-400">ASAP</span> TAXIS
        </span>
      </a>
      <nav className="hidden md:flex gap-8 text-sm text-[#99A1B3]">
        {LINKS.map(([label, href]) => (
          <a key={href} href={href} className="hover:text-white transition-colors duration-200">
            {label}
          </a>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <a
          href="tel:1300582485"
          onClick={trackContact}
          data-testid="nav-call-button"
          className="hidden sm:flex items-center gap-2 rounded-full border border-gold-400/30 px-4 py-2 text-sm text-gold-300 hover:bg-gold-400/10 transition-colors duration-200"
        >
          <Phone size={14} /> 1300 582 485
        </a>
        <a
          href="#book"
          data-testid="nav-book-button"
          className="rounded-full bg-gold-400 px-4 sm:px-5 py-2 text-sm font-bold text-ink whitespace-nowrap hover:bg-gold-300 transition-colors duration-200"
        >
          Book Now
        </a>
      </div>
    </div>
  </header>
);
